import { makeVar } from '@apollo/client';

export const defaultLeasingInterestDetail = {
  interestTypeDetailId: null,
  interestTypeId: null,
  currencyId: null,
  startDate: '',
  endDate: '',
  interestPercent: null
};

export const leasingDetailModalVar = makeVar({
  open: false,
  method: defaultLeasingInterestDetail
});
